import React, { type FC, type ReactNode, useEffect, useState } from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { env, isBuildPhase } from "@env/unsafe-public";

const startBugsnag = () => {
  if (
    env.NODE_ENV === "development" ||
    env.DEV_ENV ||
    isBuildPhase() ||
    !env.BUGSNAG_API_KEY
  ) {
    return;
  }

  if (!Bugsnag.isStarted()) {
    Bugsnag.start({
      apiKey: env.BUGSNAG_API_KEY,
      releaseStage: "production",
      plugins: [new BugsnagPluginReact()],
    });
  }

  return Bugsnag.getPlugin("react");
};

export const ErrorBoundary: FC<{ children: ReactNode }> = ({ children }) => {
  const [MaybeErrorBoundary, setErrorBoundary] = useState<React.ComponentType<{
    children?: ReactNode;
  }> | null>(null);

  useEffect(() => {
    const bugsnagPlugin = startBugsnag();
    if (bugsnagPlugin) {
      const BugsnagErrorBoundary = bugsnagPlugin.createErrorBoundary(React);
      setErrorBoundary(() => BugsnagErrorBoundary);
    }
  }, []);

  if (!MaybeErrorBoundary) {
    return <>{children}</>;
  }

  return <MaybeErrorBoundary>{children}</MaybeErrorBoundary>;
};
